<template>
  <div>
    <div class="card">
      <div class="card-header d-flex flex-column align-items-start py-3">
        <div class="h2 inline-block">
          Disparo para Plataformas de Marketing
        </div>
        <p class="mb-0">
          Acompanhe suas conversões dentro do Facebook ADS, Google ADS e Google Analytics.
        </p>
      </div>
      <div class="card-body">
        <div><label class="form-label">Eventos de Conversão<span
               class="form-help ms-2"
               data-bs-toggle="popover"
               data-bs-placement="right"
               data-bs-html="true"
               data-bs-trigger="hover"
               data-bs-content="A cada nova conversão em seu chat, um <strong>evento de conversão é disparado</strong> de forma automática para seu Google analytics e Facebook ads, com os <strong>nomes definidos abaixo</strong>."
             >?</span></label>
          <div><label class="form-check form-check-inline form-switch">
            <b-form-checkbox
              id="check-status-google"
              v-model="infoIntegre.status_google"
              name="check-manual"
              switch
              inline
              :value="1"
              :unchecked-value="0"
            />
            <span class="form-check-label"><img
              src="https://dkplayer.s3.sa-east-1.amazonaws.com/google-analytics-logo.png"
              height="100"
            ></span></label></div>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Categoria</label>
              <input
                v-model="infoIntegre.categoria"
                type="text"
                class="form-control"
                placeholder="Vsl Booster"
              >
            </div>
            <div class="col-md-4">
              <label class="form-label">Ação</label>
              <input
                v-model="infoIntegre.acao"
                type="text"
                class="form-control"
                value="Lead"
              >
            </div>
            <div class="col-md-4">
              <label class="form-label">ID da tag (opcional)</label>
              <input
                v-model="infoIntegre.id_tag"
                type="text"
                class="form-control"
                placeholder="G-1ABCDE34FG"
              >
            </div>
          </div>
        </div>
        <hr class="my-3">
        <div>
          <div><label class="form-check form-check-inline form-switch">
            <b-form-checkbox
              id="check-status-facebook"
              v-model="infoIntegre.status_facebook"
              name="check-manual"
              switch
              inline
              :value="1"
              :unchecked-value="0"
            />
            <span class="form-check-label"><img
              src="https://dkplayer.s3.sa-east-1.amazonaws.com/facebook-logo-0.png"
              height="70"
            ></span></label></div>
          <div><label class="form-label">Código do pixel<a
                 class="form-help ms-2"
                 href="https://help.leadster.com.br/article/120-como-configurar-os-eventos-do-pixel-da-meta-e-o-ga4-de-maneira-automatizada"
                 target="_blank"
                 data-bs-toggle="tooltip"
                 aria-label="Clique para saber mais"
                 data-bs-original-title="Clique para saber mais"
               ><i class="fa fa-info" /></a></label>
            <input
              v-model="infoIntegre.codigo_pixel"
              type="text"
              class="form-control"
            ></div>
          <br>
          <div><label class="form-label">Evento</label>
            <input
              v-model="infoIntegre.evento"
              type="text"
              class="form-control"
              value="Leadster-Lead"
            ></div>
        </div>
      </div>
      <div class="sc-fznJRM bTIjTR d-none d-md-block mt-3 bg-light p-3">
        <div class="align-items-start justify-content-center d-flex"><img
          src="/logo-booster.png"
          alt="VslBooster logo"
          class="me-3"
          height="50px"
        >

        </div>
        <div class="mt-1">
          <div class="h3 text-body fw-medium mb-1">
            Integre com suas plataformas de Marketing
          </div>
          <div><span class="tracking-wide mb-2">
                 Assim que um lead responder todas as perguntas, disparamos um evento de
                 conversão para suas plataformas de acordo com o nome definido acima.
               </span>
            <br>
            <span class="mb-0 tracking-wide">
              Lembrando que quanto maior o volume de conversões que o Google ou Facebook ads
              recebem através de seu site, melhor será o desempenho e aprendizado de suas campanhas.
            </span>
          </div>
        </div>
      </div>

    </div>
    <div class="fixed-button">
      <button
        id="btn-salvar-integre-sistema"
        class="btn btn-primary"
        @click="atualizaIntegreChat()"
      >
        Salvar
      </button>
    </div>
  </div>

</template>
<script>
import {
  BTabs, BTab, BFormGroup, BFormCheckboxGroup, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import IntegreSistema from '@/views/App/Chat/integreSistema.vue'
import FluxoMensagem from '@/views/App/Chat/FluxoMensagem.vue'
import { useApiAWS, useApi } from '@/composables/useApi'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import Info from './Info.vue'

const apiAws = useApiAWS()
const apiBack = useApi()

export default {

  components: {
    IntegreSistema,
    FluxoMensagem,
    BTabs,
    BTab,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    VBTooltip,
    Info,
    vSelect,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      infoIntegre: [],
      dir: 'ltr',
      chatId: this.$route.query.id_chat,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      autoPlayer: '',
      imagemSelecionada: '',
      chat: [],
    }
  },
  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    autoPlayerValue() {
      return this.autoPlayer ? 1 : 0
    },
    getDomainChateByRole: {
      get() {
        if (this.getUserData.user_role !== 'admin') {
          return this.getUserData.user_domain
        }
        return this.chat.domain
      },
      set(value) {
        this.chat.domain = value
      },
    },
  },
  watch: {

    getDomainChateByRole: {
      handler() {
        this.chat.domain = this.getDomainChateByRole
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'integreSistema')
    this.buscarInfoChat()
  },

  created() {
    window.addEventListener('resize', this.initTrHeight, this.Listavariaveis)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },

  methods: {
    mudarComponente() {
      this.$store.commit('AppChatbooster/SET_CURRENT_TAB', {
        title: 'Gerenciar Fluxos',
        component: 'chat',
      })
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ params: {}, query: {} })
      }
    },
    async buscarInfoChat() {
      await apiBack.get(`/getIntegreChat/${this.chatId}`)
        .then(async response => {
          if (response.data[0] === undefined) {
            apiBack.post(`/atualizaIntegreChat/${this.chatId}`, {
              categoria: '',
              acao: '',
              id_tag: '',
              codigo_pixel: '',
              evento: '',
              status_google: 0,
              status_facebook: 0,
            })
            this.buscarInfoChat()
          } else {
            this.infoIntegre = response.data[0]
          }
        })
        .catch(err => console.error(err))
    },
    fluxo() {
      this.$router.push({ name: 'fluxoMensagem' })
    },
    async atualizaIntegreChat() {
      this.$message({
        type: 'success',
        message: 'Salvo com sucesso',
      })
      await apiBack.post(`/atualizaIntegreChat/${this.chatId}`, {
        categoria: this.infoIntegre.categoria,
        acao: this.infoIntegre.acao,
        id_tag: this.infoIntegre.id_tag,
        codigo_pixel: this.infoIntegre.codigo_pixel,
        evento: this.infoIntegre.evento,
        status_google: this.infoIntegre.status_google,
        status_facebook: this.infoIntegre.status_facebook,
      })
        .then(() => {
        })
        .catch(err => console.error(err))
    },
  },

}
</script>
<style lang="scss" scoped>
.fixed-button {
  position: fixed;
  bottom: 20px; /* Ajuste o valor conforme necessário para posicionar o botão verticalmente */
  right: 20px; /* Ajuste o valor conforme necessário para posicionar o botão horizontalmente */
  z-index: 999; /* Certifique-se de que o botão esteja acima de outros elementos na página, se necessário */
}
</style>
